export const referenceDataMapping = async (data) => {
	async function mapAllData(data) {
		await updateOccupationData(data);
		await updateCoverLimitData(data);
		await auraExclusionWordingList(data);
		return data;
	}

	//* Separate the Aura Exclusions in to their own
	//* object. This is used when an underwriter (with greater privileges)
	//* to add additional exclusions.
	async function auraExclusionWordingList(data) {
		const auraExclusionWordingList = [data.auraExclusionWordingList][0];

		const lifeExclusions = auraExclusionWordingList.filter(
			(x) => x.riskTypeCode.trim() === "LIF"
		);
		const newLifeExclusions = lifeExclusions.map((lifeExclusion) => {
			return {
				display: `${lifeExclusion.auraExclusionCode} - ${lifeExclusion.riskTypeCode}`,
				name: `${lifeExclusion.auraExclusionCode}`,
				...lifeExclusion,
			};
		});

		const ciExclusions = auraExclusionWordingList.filter(
			(x) => x.riskTypeCode.trim() === "CI"
		);

		const newCiExclusions = ciExclusions.map((ciExclusion) => {
			return {
				display: `${ciExclusion.auraExclusionCode} - ${ciExclusion.riskTypeCode}`,
				name: `${ciExclusion.auraExclusionCode}`,
				...ciExclusion,
			};
		});

		const puwExclusions = auraExclusionWordingList.filter(
			(x) => x.riskTypeCode.trim() === "PUW"
		);

		const newPuwExclusions = puwExclusions.map((puwExclusion) => {
			return {
				display: `${puwExclusion.auraExclusionCode} - ${puwExclusion.riskTypeCode}`,
				name: `${puwExclusion.auraExclusionCode}`,
				...puwExclusion,
			};
		});

		let newArray = [];
		newArray.push({ lifeExclusions: [newLifeExclusions] });
		newArray.push({ ciExclusions: [newCiExclusions] });
		newArray.push({ puwExclusions: [newPuwExclusions] });

		data.auraExclusionWordingList = newArray;

		return data;
	}

	async function updateOccupationData(data, mapNew = true) {
		// We may just want to return the data as is.
		if (mapNew === false) return data;

		// The Occupation List is used in the radio button list.
		// We need the occupationId for eLife and
		// the occupationTypeCode is needed by AURA
		let dataArray = [];

		const occupations = data.occupationTypeList;
		occupations.forEach((occupation) => {
			const itemData = {
				value: occupation.occupationId + "-" + occupation.occupationTypeCode,
				name: occupation.occupationDescription,
			};
			dataArray.push(itemData);
		});

		data.occupationTypeList = dataArray;
		return data;
	}

	async function updateCoverLimitData(data, mapNew = true) {
		// We may just want to return the data as is.
		if (mapNew === false) return data;

		//* Life cover
		const minAgeLifeCover = {};
		const maxAgeLifeCover = {};

		//* Permanently unable to work cover
		const minAgePUWCover = {};
		const maxAgePUWCover = {};

		//* Critical illness cover
		const minAgeCICover = {};
		const maxAgeCICover = {};

		//* min and max age
		let smallestMinAge = Infinity;
		let largestMaxAge = -Infinity;

		for (const item of data.coverLimitAmountList) {
			minAgeLifeCover[item.minAge] = item.lifeMinCover;
			maxAgeLifeCover[item.maxAge] = item.lifeMaxCover;

			minAgePUWCover[item.minAge] = item.puwMinCover;
			maxAgePUWCover[item.maxAge] = item.puwMaxCover;

			minAgeCICover[item.minAge] = item.ciMinCover;
			maxAgeCICover[item.maxAge] = item.ciMaxCover;

			smallestMinAge = Math.min(smallestMinAge, item.minAge);
			largestMaxAge = Math.max(largestMaxAge, item.maxAge);
		}

		const minAgeLCobj = { minAgeLifeCover: minAgeLifeCover };
		const maxAgeLCobj = { maxAgeLifeCover: maxAgeLifeCover };

		const minAgePUWobj = { minAgePUWCover: minAgePUWCover };
		const maxAgePUWobj = { maxAgePUWCover: maxAgePUWCover };

		const minAgeCIobj = { minAgeCICover: minAgeCICover };
		const maxAgeCIobj = { maxAgeCICover: maxAgeCICover };

		const ageRangeObj = {
			smallestMinAge: smallestMinAge,
			largestMaxAge: largestMaxAge,
		};

		const newLimitsData = [];
		newLimitsData.push(minAgeLCobj);
		newLimitsData.push(maxAgeLCobj);

		newLimitsData.push(minAgePUWobj);
		newLimitsData.push(maxAgePUWobj);

		newLimitsData.push(minAgeCIobj);
		newLimitsData.push(maxAgeCIobj);

		newLimitsData.push(ageRangeObj);

		data.coverLimitAmountList = newLimitsData;
		return data;
	}

	//
	const referenceDataMappedData = await mapAllData(data);

	return referenceDataMappedData;
};
